<template>
  <div class="inner-graph-content">
    <Spinner :isLoading="isLoading" />
    <div class="inner-graph-content">
      <div class="search-24-area" style="padding-top:0">
        <div class="space" style="height:20px"></div>
        <div class="search-24-check-area clearfix">
          <ul class="search-24-calendar clearfix">
            <li><span class="txt-24-pos">日付選択：</span></li>
            <li :class="[isSelectedDateValid ? '' : 'form-error']">
              <input
                v-datepicker type="text"
                :class="['pickupdate', isSelectedDateValid ? '' : 'input-error']"
                id="pickupdate"
                autocomplete="off"
                v-on:keyup.enter="hideDatePicker()"
                :value="dateSelected"
                @input="onInputDatePicker()"
                @click="onInputDatePicker()"
              />
              <input id="input-pickupdate" type="hidden" time="0"/>
              <span v-if="!isSelectedDateValid">{{$t('cannot_specify_the_entered_date')}}</span>
            </li>
          </ul>
          <!-- /.btn-recep-search-pos -->
          <ul class="period-setting mb20">
            <li>期間設定：</li>
            <li v-for="(period, index) in filterPeriod" :key="index">
              <div :class="[index == periodActive ? 'btn-type-active' : 'btn-type']">
                <a href="javascript:" @click="changePeriod(index)"><p>{{period}}</p></a>
              </div>
            </li>
          </ul>
        </div>
        <!-- /.search-24-check-area -->
        <ul class="search-24-icon-area">
          <li style="font-size: 16px; vertical-align: bottom;">発作種類：</li>
          <li v-for="(type, index) in listShortcat" :key="index"
            @click="onlistShortcat(type.shortcat_index)"
            :class="[
              (listShortcat.length - 1 == index && periodActive == 1) ? 'd-none' :'',
              listShortcatActive.includes(type.shortcat_index) ? listIcon[type.shortcat_index] : 'type-inactive dis-'+listIcon[type.shortcat_index], 
            ]" style="background-size: 16px !important;"
          >
            <a href="javascript:">{{type.shortcat_name}}</a>
          </li>
        </ul>
        <div v-if="listDateDisplay.length && Object.keys(sleepDataFormated).length" class="search-24-table-area" style="position: sticky;z-index: 10;overflow:hidden">
          <table :class="[periodActive == 0 ? 'month-table' : 'weekly-table']">
            <tbody>
              <tr v-for="row in Array.from({length: 25}, (_, i) => i - 1)" :key="row">
                <!-- date-row -->
                <template v-if="row == -1">
                  <th class="time-ttl fix-cell">時間</th>
                  <th v-for="(date, column) in listDateDisplay" :key="row+'~'+column"
                      :id="'date-'+date"
                      :class="[
                        new Date(date).getDay() == 6 ? 'date-saturday' : 
                        (sleepDataFormated[date].isHoliday || new Date(date).getDay() == 0) ? 'date-holiday' : 'date-weekday'
                      ]"
                  >
                    {{(new Date(date).getMonth()+1)+'/'+new Date(date).getDate()}}
                  </th>
                </template>
                <!-- date-row -->
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.search-24-icon-area -->
        <div v-if="listDateDisplay.length && Object.keys(sleepDataFormated).length" class="search-24-table-area" @scroll="handleScrollTable24h" >
          <table :class="[periodActive == 0 ? 'month-table' : 'weekly-table']">
            <tbody>
              <tr v-for="row in Array.from({length: 25}, (_, i) => i - 1)" :key="row">
                 <!-- row from 0->23 -->
                <template v-if="row != -1">
                  <td :class="[
                      'fix-cell',
                      row == 11 ? 'time-noon' : '',
                      row == 5 ? 'line-dotted' : '',
                      row == 6 ? 'non-border-top' : '',
                      row == 17 ? 'line-dotted' : '',
                      row == 18 ? 'non-border-top' : '',
                    ]">{{row}}</td>
                  <td v-for="(date, column) in listDateDisplay" :key="row+'~'+column"
                    :class="[
                    (sleepDataFormated[date].sleepTime && sleepDataFormated[date].sleepTime.includes(row)) ? 'time-sleep' : '',
                      row == 11 ? 'time-noon' : '',
                      row == 5 ? 'line-dotted' : '',
                      row == 6 ? 'non-border-top' : '',
                      row == 17 ? 'line-dotted' : '',
                      row == 18 ? 'non-border-top' : '',
                    ]"
                  >
                    <template v-if="sleepDataFormated[date].listSeizure && sleepDataFormated[date].listSeizure[row]">
                      <!-- monthly display -->
                      <ul
                        v-if="periodActive == 0"
                        class="month-icon-pos"
                      >
                        <!-- if have more than 2 active, and enable multi icon, show the multi icon -->
                        <!-- or show the active icon if it exists and enable -->
                        <li>
                          <span
                            :class="(getIconDataForMonthMode(sleepDataFormated[date].listSeizure[row]) || 'd-none')"
                            v-b-tooltip="{
                              disabled: false,
                              html: true,
                              title: tooltipMethod(sleepDataFormated[date].listSeizure[row], date),
                              placement: 'bottomright',
                              variant: 'light',
                              trigger: 'focus hover',
                            }" style="height: 15px;width: 15px;line-height: 15px;background-size: 15px;padding: 0;"
                          >
                            &nbsp;
                          </span>
                        </li>
                      </ul>
                      <!-- monthly display -->
                      <!-- weekly display -->
                      <ul
                        v-else-if="periodActive == 1 && numberSeizureWillShow(listShortcatActive, sleepDataFormated[date].listSeizure[row]) > 0"
                        class="weekly-icon-pos"
                        v-b-tooltip="{
                          disabled: false,
                          html: true,
                          title: tooltipMethod(sleepDataFormated[date].listSeizure[row], date),
                          placement: 'bottomright',
                          variant: 'light',
                          trigger: 'focus hover',
                        }"
                      >
                      <template v-for="(seizure, key, index) in sleepDataFormated[date].listSeizure[row]">
                        <li v-if="index <= 6 && listShortcatActive.includes(convertKey(key))" :key="index">
                          <!-- show max is 6 active, if more after the 6th active, show ... -->
                          <span v-if="index >= 6 && numberSeizureWillShow(listShortcatActive, sleepDataFormated[date].listSeizure[row]) > 6">
                            ...
                          </span>
                          <span v-else
                            :class="[listIcon[convertKey(key)]]" style="height: 15px;width: 15px;line-height: 15px;">
                            {{ seizure.length }}
                          </span>
                        </li>
                      </template>
                      </ul>
                      <!-- weekly display -->
                    </template>
                  </td>
                </template>
                <!-- row from 0->23 -->
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.search-24-table-area -->
        <div class="search-24-info-area clearfix">
            <ul class="setting-pattern clearfix">
                <li class="ico-setting-time">-アプリで入力した睡眠記録が表示されています</li>
            </ul>
            <!-- /.setting-pattern -->
            <p class="setting-caution">※発作種類を全て見る場合は、発作が起きた時間枠をクリックまたは、タップしてください。</p>
        </div>
        <!-- /.search-24-info-area -->
      </div>    
      <!-- /.search-24-area -->
    </div>  
    <!-- /.inner-graph-content -->
  </div>
</template>
<script>
import {mapState} from 'vuex'
import moment from 'moment'
import Spinner from "@/js/components/Spinner"
import Calendar from 'v-calendar/lib/components/calendar.umd'
import {VBTooltip} from 'bootstrap-vue'
import { getOffset } from '@/js/commons/commons'
moment.suppressDeprecationWarnings = true

const WIDTH_OF_MENU_BAR = 240
const PADDING = 20
const WIDTH_OF_FIRST_COL = 60
const WIDTH_OF_WEEK_COL = 180
export default {
    components: {
      Spinner,
      VBTooltip,
      Calendar
    },
    directives: {
      datepicker: {
        inserted(el) {
          $(`#${el.id}`).datepicker({
            showOn: 'both',
            buttonImage: ('./../common/img/icon_pink_calendar.png'),
            buttonImageOnly: true,
            numberOfMonths: 1,     // 1ヶ月分表示
            stepMonths: 1,         // 月の移動を1ヶ月単位とする
            showButtonPanel: false, // ボタン領域を表示
            maxDate: '0',
            dateFormat: 'yy/mm/dd',
            onSelect : function (dateText, inst) {
              document.getElementById('input-pickupdate').setAttribute(
                'time',
                parseInt(document.getElementById('input-pickupdate').getAttribute('time')) + 1
              )
              inst.input.trigger('change')
            }
          })
        }
      }
    },
    props: {
      activePage: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        isLoading: false,
        isDataLoadingFirstTime: true,
        filterPeriod: ["１ヶ月","１週間"],
        periodActive: 0,
        listShortcatActive: [],
        listShortcat: [],
        listIcon: {
          0: "icon-seizure-a",
          1: "icon-seizure-b", 
          2: "icon-seizure-c",
          3: "icon-seizure-d", 
          4: "icon-seizure-e",
          5: "icon-seizure-f",
          other: "icon-seizure-etc",
          'seizure-multi': "icon-multiple"
        },
        
        listDisIcon: [
          "icon-dis-seizure","icon-dis-multiple"
        ],
        listDateDisplay:[],
        sleepDataFormated: {},
        isSelectedDateValid: true,
        dateSelected: moment(new Date()).format('YYYY/MM/DD'),
        previousDate: moment().subtract(1, 'month').startOf('month'),
        nextDate: moment().endOf('month'),
        minDate: moment('1980/01/01'),
        maxDate: moment().endOf('month'),
      }
    },
    created() {
      window.addEventListener("resize", this.setTopStick)
      window.addEventListener("click", this.setTopStick)
    },
    watch: {
      periodActive() {
        setTimeout(() => {
          this.handleScrollBarPosition((this.periodActive == 0 ? 'month-mode' : 'week-mode'), this.dateSelected)
        }, 10);
      },
      async activePage() {
        if(this.isDataLoadingFirstTime && this.activePage === 'sleep-management') {
          let params = {
            from_date: moment(this.previousDate).subtract(1, 'days').format('YYYY/MM/DD'),
            to_date: this.nextDate.format('YYYY/MM/DD'),
            childId: this.info.id
          }
          await this.getDataSleep(params, 'create')
          this.handleScrollBarPosition('month-mode', this.dateSelected)
          this.isDataLoadingFirstTime = false

          document.getElementsByClassName('search-24-table-area')[0].scrollLeft = document.getElementsByClassName('search-24-table-area')[0].offsetWidth
          document.getElementsByClassName('search-24-table-area')[1].scrollLeft = document.getElementsByClassName('search-24-table-area')[0].offsetWidth
          this.setTopStick()
        }
      },
    },
    computed: {
      ...mapState({
        info: state => state.patient.info,
        sleep: state => state.patient.sleep,
      }),
    },
    mounted() {
      let self = this
      document.getElementById('input-pickupdate').value = document.getElementById('pickupdate').value
      let iconDatePicker = document.getElementsByClassName('ui-datepicker-trigger')[0]
      iconDatePicker.addEventListener('click', (e) => {
        document.getElementById('ui-datepicker-div').style.zIndex = 11
      });
      document.getElementById('pickupdate').onchange = async function() {
        await setTimeout(async () => {
          let inputValue = null
          if(parseInt(document.getElementById('input-pickupdate').getAttribute('time')) >=2 ) {
            inputValue = document.getElementById('input-pickupdate').value
          }
          else {
            inputValue = document.getElementById('pickupdate').value
          }
          let regex = new RegExp(/^(?:\d{4}\/(?:(?:(?:(?:0[13578]|1[02])\/(?:0[1-9]|[1-2][0-9]|3[01]))|(?:(?:0[469]|11)\/(?:0[1-9]|[1-2][0-9]|30))|(?:02\/(?:0[1-9]|1[0-9]|2[0-8]))))|(?:(?:\d{2}(?:0[48]|[2468][048]|[13579][26]))|(?:(?:[02468][048])|[13579][26])00)\/02\/29)$/)
          self.isSelectedDateValid = (
            regex.test(inputValue) &&
            !moment(inputValue).isAfter(moment()) &&
            !moment(inputValue).isBefore(moment(self.minDate).add(1, 'month'))
          )
          if(self.dateSelected !== inputValue) {
            self.dateSelected = inputValue
            if(self.isSelectedDateValid) {
              await self.onSubmitCalendar()
            }
          }
          document.getElementById('pickupdate').value = inputValue
          setTimeout(() => {
            document.getElementById('input-pickupdate').setAttribute('time', 0)
          }, 20);
        }, 5);
        
      }
    },
    methods: {
      setTopStick(){
        if (document.getElementsByClassName('patient-menu').length > 0) {
          let patientMenu = document.getElementsByClassName('patient-menu')[0].offsetHeight + 50
          
          let space = document.getElementsByClassName('space')[0]
          space.style.top = patientMenu+'px'
  
          let checkArea = document.getElementsByClassName('search-24-check-area')[0]
          checkArea.style.top = space.offsetHeight + patientMenu+'px'
  
          let iconArea = document.getElementsByClassName('search-24-icon-area')[0]
          iconArea.style.top = space.offsetHeight + patientMenu + checkArea.offsetHeight + 'px'
  
          if (document.getElementsByClassName('search-24-table-area').length > 0) {
            document.getElementsByClassName('search-24-table-area')[0].style.top = space.offsetHeight + patientMenu + checkArea.offsetHeight + iconArea.offsetHeight - 2 + 'px'
          }
        }
      },
      onInputDatePicker() {
        document.getElementById('input-pickupdate').value = document.getElementById('pickupdate').value
        document.getElementById('ui-datepicker-div').style.zIndex = 11
      },
      async hideDatePicker() {
        document.getElementById('pickupdate').blur()
        document.getElementById('ui-datepicker-div').style.display =  'none'
      },
      handleScrollBarPosition(type, date) {
        let elPosition = null
        let elTableArea = document.getElementsByClassName('search-24-table-area')[1]
        let elTableAreaUpper = document.getElementsByClassName('search-24-table-area')[0]
        switch (type) {
          case 'month-mode':
          case 'scroll-left':
            date = moment(date).startOf('month').format('YYYY/MM/DD')
            elPosition = getOffset(document.getElementById('date-'+date))
            elTableArea.scrollLeft = elPosition.left - (WIDTH_OF_MENU_BAR + PADDING + WIDTH_OF_FIRST_COL)
            break;
          case 'week-mode':
              date = moment(date).format('YYYY/MM/DD')
              elPosition = getOffset(document.getElementById('date-'+date))
              elTableArea.scrollLeft = elPosition.left - ( WIDTH_OF_MENU_BAR + PADDING +  (elTableArea.offsetWidth - WIDTH_OF_WEEK_COL) )
            break;
        }
        elTableAreaUpper.scrollLeft = elTableArea.scrollLeft
      },
      async getDataSleep(params, action) {
        let isDataExists = true
        let dateFormated = null
        let listDate = [...this.listDateDisplay]
        if(action === 'calendar') { listDate = [] }
        let startDateCheck = moment(params.from_date)
        let endDateCheck = moment(params.to_date)
        while(!startDateCheck.isAfter(endDateCheck)) {
          dateFormated = startDateCheck.format('YYYY/MM/DD')
          if(!listDate.includes(dateFormated)) { listDate.push(dateFormated) }
          if(!this.sleepDataFormated[dateFormated]) { isDataExists = false }
          startDateCheck.add(1, 'days')
        }
        listDate.sort()
        if( action !== 'scrollRight') { listDate.shift() }
        if(!isDataExists) {
          this.isLoading = true
          if (this.$store.state.auth.typeOfUser === 'pharmacy') {
            params.pharmacy_user_id = this.$store.state.auth.doctorInfo.id
          }
          await this.$store.dispatch("patient/getSleepData", params)
          if(action === 'create') {
            Object.values(this.sleep.seizures_shortcat).forEach(val => {
              if(val) {
                if(val.shortcat_name == null) {
                  switch (val.shortcat_index) {
                    case 0: val.shortcat_name = 'A'; break;
                    case 1: val.shortcat_name = 'B'; break;
                    case 2: val.shortcat_name = 'C'; break;
                    case 3: val.shortcat_name = 'D'; break;
                    case 4: val.shortcat_name = 'E'; break;
                    case 5: val.shortcat_name = 'F'; break;
                    default:
                      break;
                  }
                }
                this.listShortcat.push(val)
              }
            })
            this.listShortcat.push({ id: null, shortcat_index: 'other', shortcat_name: this.$t('others') })
            this.listShortcat.length > 1 ? this.listShortcat.push({ id: 'seizure-multi', shortcat_index: 'seizure-multi', shortcat_name: '複数発生' }) : null
            this.listShortcat.sort((a, b) => {
              if (a.shortcat_index.toString() < b.shortcat_index.toString()) { return -1; }
              if (a.shortcat_index.toString() > b.shortcat_index.toString()) { return 1; }
              return 0;
            });
            this.listShortcatActive = this.listShortcat.length ? this.listShortcat.map(item => { return item.shortcat_index}) : []
          }
          this.formatData()
          this.isLoading = false
        }
        this.listDateDisplay = listDate
      },
      formatData() {
        let listShortcatId = this.listShortcat.map(t => t.id)
        this.sleep.seizures_shortcat.forEach(shortcat => {
          if(shortcat && !listShortcatId.includes(shortcat.id)) {
            this.listShortcat.push(shortcat)
            this.listShortcat.sort((a, b) => {
              if (a.shortcat_index.toString() < b.shortcat_index.toString()) { return -1; }
              if (a.shortcat_index.toString() > b.shortcat_index.toString()) { return 1; }
              return 0;
            });
            if(!this.listShortcatActive.includes(shortcat.id)) {
              this.listShortcatActive.push(shortcat.shortcat_index)
            }
          }
        })
        let sleepTimeNextDate = {}
        this.sleep.seizure_data.forEach(seizureData => {
          let dateFormated = seizureData.date.replaceAll('-', '/')
          this.sleepDataFormated[dateFormated] = {
            isHoliday: seizureData.is_holiday,
            seizures: seizureData.seizures,
            children_sleep_times: seizureData.children_sleep_times,
            sleepTime: [],
            listSeizure: null
          }
          let dateChecking = dateFormated
          if(this.sleepDataFormated[dateFormated].children_sleep_times || sleepTimeNextDate[dateChecking]?.length) {
            let sleepTime = []
            sleepTime = sleepTime.concat(sleepTimeNextDate[dateChecking])
            if(this.sleepDataFormated[dateFormated].children_sleep_times) {
              let timeCheck = 0
              let timeStart = 0
              let timeEnd = 0
              let isNextDate = false
              this.sleepDataFormated[dateFormated].children_sleep_times.forEach(sleepData => {
                isNextDate = false
                timeCheck = moment(sleepData.event_start_time).set({minute:0,second:0,millisecond:0})
                timeStart = moment(sleepData.event_start_time)
                timeEnd = moment(sleepData.event_end_time)
                let nextDate = moment(sleepData.event_start_time).add(1, 'days').set({hour:0,minute:0,second:0,millisecond:0})
                while(timeEnd.isAfter(timeStart) && timeEnd.isAfter(timeCheck)) {
                  if(isNextDate){
                    sleepTimeNextDate[dateChecking].push(timeCheck.hour())
                  }
                  else {
                    sleepTime.push(timeCheck.hour())
                  }
                  timeCheck.add(1, 'hours')
                  if(!timeCheck.isBefore(nextDate)) {
                    isNextDate = true
                    nextDate.add(1, 'days')
                    dateChecking = moment(timeCheck).format('YYYY/MM/DD')
                    sleepTimeNextDate[dateChecking] = []
                  }
                }
              })
            }
            this.sleepDataFormated[dateFormated].sleepTime = sleepTime
          }
          if(this.sleepDataFormated[dateFormated].seizures) {
            let listSeizure = {}
            this.sleepDataFormated[dateFormated].seizures.forEach(item => {
              let hourStart = parseInt(item.event_start_time.split(':')[0])
              let shortcatData = this.listShortcat.find(t => t.id === item.seizure_shortcat_id)
              listSeizure[hourStart] ? null : listSeizure[hourStart] = {}
              listSeizure[hourStart][shortcatData ? shortcatData.shortcat_index : 'other'] ? null : listSeizure[hourStart][shortcatData ? shortcatData.shortcat_index : 'other'] = []
              listSeizure[hourStart][shortcatData ? shortcatData.shortcat_index : 'other'].push({
                shortcat_data: shortcatData ? shortcatData : {shortcat_name: this.$t('others')},
                event_start_time: item.event_start_time,
                event_end_time: item.event_end_time,
              })
            })
            this.sleepDataFormated[dateFormated].listSeizure = listSeizure
          }
        })
      },
      async onSubmitCalendar() {
        //from_date is the first date in the previous month of the date selected
        //last_date is the last date in the month of the date selected
        let from_date = moment(this.dateSelected).subtract(1, 'month').startOf('month')
        let to_date = moment(this.dateSelected).endOf('month')
        let params = {
          from_date: moment(from_date).subtract(1, 'days').format('YYYY/MM/DD'),
          to_date: to_date.format('YYYY/MM/DD'),
          childId: this.info.id
        }
        this.previousDate = from_date,
        this.nextDate = to_date
        await this.getDataSleep(params, 'calendar')
        this.handleScrollBarPosition((this.periodActive == 0 ? 'month-mode' : 'week-mode'), this.dateSelected)
      },
      changePeriod(value) {
        this.periodActive = value
      },
      convertKey(key) {
        return isNaN(parseInt(key)) ? key : parseInt(key)
      },
      onlistShortcat (index){
        if(this.listShortcatActive.includes(index)) {
          // auto disable icon-multi if have less than 2 seizure-icons actived
          if(
            (this.listShortcatActive.length <=3 && this.listShortcatActive.includes('seizure-multi')) ||
            (this.listShortcatActive.length <=2 && !this.listShortcatActive.includes('seizure-multi'))
          ) {
            let index = this.listShortcatActive.indexOf('seizure-multi')
            index > -1 ? this.listShortcatActive.splice(index, 1) : null
          }
          let i = this.listShortcatActive.indexOf(index)
          i > -1 ? this.listShortcatActive.splice(i,1) : null
        }
        else {
          // auto ative icon-multi if the seizure-icon actived increase from 1 to 2
          // can not active icon-multi if only have 1 seizure-icon actived
          if(this.listShortcatActive.length == 1 && index !== 'seizure-multi') {
            this.listShortcatActive.push('seizure-multi')
          }
          if(index !== 'seizure-multi' || (index === 'seizure-multi' && this.listShortcatActive.length > 1)) {
            this.listShortcatActive.push(index)
          }
        }
      },
      tooltipMethod(data, date) {
        let htmlContent = ""
        htmlContent = "<div class='tooltip-h'>"
        for (const [key, val] of Object.entries(data)) {
          if(this.listShortcatActive.includes(this.convertKey(key))) {
            htmlContent += `<p class="${this.listIcon[key]} pb-1">${val[0].shortcat_data.shortcat_name}（${val.length}回）</p>`
            val.forEach( (seizureTime, index) => {
              htmlContent += `<ul class='seizure-time-list ${(val.length - 1) == index ? 'mb10' : '' }'>`
              htmlContent += `    <li><span class='list-sub-ttl'>発作開始時間：</span>${seizureTime.event_start_time}</li>`
              htmlContent += "    <li class='list-arrow'></li>"
              htmlContent += `    <li><span class='list-sub-ttl'>発作終了時間：</span>${seizureTime.event_end_time}</li>`
              htmlContent += `    <li>(
                ${this.getTimeSeizure(date +' '+ seizureTime.event_start_time, date +' '+ seizureTime.event_end_time)}
              )</li>`
              htmlContent += "</ul>"
            })
          }
        }
        htmlContent += "</div>"
        return htmlContent
      },
      getTimeSeizure(startTime, endTime) {
        let result = moment.utc(moment(endTime).diff(moment(startTime)))
        return (
          (result.hours() ? result.hours()+'時間' : '')
          + (result.minutes() + '分')
          + (result.seconds() ? result.seconds()+'秒' : '')
        )
      },
      getIconDataForMonthMode(data) {
        let listShortCatIndexActive = Object.keys(data).filter(shortcat => this.listShortcatActive.includes(this.convertKey(shortcat)))
        if(listShortCatIndexActive.length > 1 && this.listShortcatActive.includes('seizure-multi')) {
          return 'icon-multiple'
        }
        else if(listShortCatIndexActive.length == 1 && this.listShortcatActive.includes(this.convertKey(listShortCatIndexActive[0]))) {
          return this.listIcon[listShortCatIndexActive]
        }
        else {
          return null
        }
      },
      numberSeizureWillShow(listTypeActive, listSeizure) {
        let count = 0
        Object.keys(listSeizure).forEach(key => {
          if(listTypeActive.includes(key) || listTypeActive.includes(parseInt(key))) {
            count++
          }
        })
        return count
      },
      getShortcatIndexinTableCell(date, row) {
        return this.convertKey(Object.keys(this.sleepDataFormated[date].listSeizure[row])[0])
      },
      async handleScrollTable24h(e) {
        // get data when scroll max to the left
        // get data for 2 week previous
        // cannot get data before minDate
        if(e.target.scrollLeft == 0 && this.previousDate.isAfter(this.minDate)) {
          let newPreviousDate = moment(this.previousDate).subtract(1, 'month')
          let params = {
            from_date: newPreviousDate.isBefore(this.minDate) ? this.minDate.format('YYYY/MM/DD') : moment(newPreviousDate).subtract(1, 'days').format('YYYY/MM/DD'),
            to_date: this.previousDate.format('YYYY/MM/DD'),
            childId: this.info.id
          }
          await this.getDataSleep(params, 'scrollLeft')
          this.handleScrollBarPosition('scroll-left', this.previousDate)
          this.previousDate = newPreviousDate
          // e.target.scrollLeft = e.target.scrollWidth > 4000 ? 150 : 50
        }
        // get data when scroll max to the right
        // get data for next 2 week 
        // cannot get data future
        else if(Math.ceil(e.target.scrollLeft + e.target.offsetWidth + 1) >= e.target.scrollWidth && this.nextDate.isBefore(this.maxDate)) {
          let newNextDate = moment(this.nextDate).add(1, 'month').endOf('month')
          let params = {
            from_date: this.nextDate.format('YYYY/MM/DD'),
            to_date: newNextDate.isAfter(this.maxDate) ? this.maxDate.format('YYYY/MM/DD') : newNextDate.format('YYYY/MM/DD'),
            childId: this.info.id
          }
          this.nextDate = newNextDate
          await this.getDataSleep(params, 'scrollRight')
          document.getElementsByClassName('search-24-table-area')[0].scrollLeft = e.target.scrollLeft
        } else {
          document.getElementsByClassName('search-24-table-area')[0].scrollLeft = e.target.scrollLeft
        }
      }
    },
}
</script>
<style scoped>
  .input-error {
    background-color: #ffe6e6 !important;
  }
  .form-error {
    position: relative;
  }
  .form-error span{
    position: absolute;
    left: 0;
    bottom: -23px;
    color: red;
    font-size: 0.8rem;
  }
  .non-border-top {
    border-top: 0 !important;
  }
</style>